import React, {useEffect, useMemo, useState} from "react";
import {useStore} from "../../hooks/useStore";
import {generateRandomOrderNumber} from "../../utils/helpers";
import {useTranslation} from "react-i18next";
import Exceljs from "exceljs";
import {message, Modal} from "antd";
import {Redirect, useHistory} from "react-router-dom";
import {useFetch} from "../../hooks/useFetch";
import {trackCreateDelivery} from "../../utils/analytics";
export const useCreateDeliveryRequest = ({isFromCustomerTheme}) => {
    const stores = useStore();
    const {t} = useTranslation();
    const history = useHistory();

    //#region state and variables
    const productPrototype = {
        //productName: "",
        productName: "Test Ürün",
        //ingredients: "",
        ingredients: "Test İçerik",
        amount: 1, //default 1
        productDesiAmount: 1, //always 1
        return: false, //always false
        willBeDeleted: false, //always false
        isTrial: false //always false
    };
    const orderPrototype = {
        index: 0, //default 0, increment for each order
        pickupInfoIndex: 1, //always 1
        //receiverName: "",
        receiverName: "",
        receiptNumber: "", // Yeni alan: fiş numarası
        receiverAddress: "",
        //receiverAddressDetail: "",
        receiverAddressDetail: "",
        //receiverPhone: "",
        receiverPhone: "",
        //note: "",
        note: "",
        receiverCity: "",
        orderNumber: generateRandomOrderNumber(), //create a unique number for each order, six digits
        paymentType: "", //default unspecified
        price: "0", //default 0
        dontRingTheBell: false, //always false
        receiverLocation: undefined, //default 0,0
        products: [productPrototype], //array of productPrototype
        barcodeIsRequired: false, //always false
        source: history.location.pathname === "/create-delivery-request" ? "manuelv2" : "manuelv1"
    };

    const initialPickupPointId =
        stores.meStore.selectedSubCompanyId !== null ||
        stores.meStore.selectedSubCompanyId !== "" ||
        stores.meStore.selectedSubCompanyId !== undefined
            ? stores.meStore.selectedSubCompanyId
            : "";
    const formData = {
        data: {
            pickupInfos: [
                {
                    pickupPointId: initialPickupPointId,
                    index: 1
                }
            ],
            courierType: "motorCourier", //always motorCourier
            deliveryType: "delivery", //always delivery
            orders: [orderPrototype] //array of orderPrototype
        }
    };

    const [fromCustomerTheme] = useState(isFromCustomerTheme);
    const [form, setForm] = useState(formData);
    const [errors, setErrors] = useState({});
    const [selectedCompany, setSelectedCompany] = useState();
    const [selectedSubCompany, setSelectedSubCompany] = useState();
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [showCreditWarningModal, setShowCreditWarningModal] = useState(false);
    const [creditWarningMessage, setCreditWarningMessage] = useState("");

    const [openUploadModalFn, setOpenUploadModalFn] = useState(null);
    //#endregion state and variables

    const getCellText = cell => {
        const value = cell?.value;
        if (value == null) return "";
        if (typeof value === "object") {
            if (Array.isArray(value.richText)) {
                return value.richText.map(part => part?.text || "").join("");
            }
            if (value.text != null) return value.text; // hyperlink hücresi {text, hyperlink}
            if (value.result != null) return value.result; // formül hücresi {formula, result}
            if (value instanceof Date) return value;
            return "";
        }
        return value;
    };

    const handleExcelUpload = async data => {
        try {
            const workbook = new Exceljs.Workbook();
            await workbook.xlsx.load(data);
            const json = JSON.stringify(workbook.model);
            const rows = JSON.parse(json).worksheets[0].rows.filter(
                r => r?.cells?.[0]?.value != undefined
            );
            rows.shift();

            const createdOrders = rows.map((row, rowIndex) => {
                const {cells} = row;
                const [
                    orderNumber,
                    receiverName,
                    receiverPhone,
                    receiverAddress,
                    receiverAddressDetail,
                    receiverLocationString,
                    productName,
                    amount,
                    ingredients,
                    _index, // Excel'deki index sütunu - kullanmıyoruz
                    pickupInfoIndex
                ] = cells;

                const rawLocation = getCellText(receiverLocationString);
                const location = (rawLocation !== "" ? rawLocation.toString() : "0,0")
                    .replace(/ /g, "")
                    .split(",");
                const lat = parseFloat(location[0]);
                const lon = parseFloat(location[1]);
                const receiverLocation = {
                    lat: Number.isFinite(lat) ? lat : 0,
                    lon: Number.isFinite(lon) ? lon : 0
                };

                const receiverPhoneText = getCellText(receiverPhone).toString();

                return {
                    index: rowIndex, // Array index kullan, Excel değerini değil
                    pickupInfoIndex: getCellText(pickupInfoIndex) || null,
                    receiverName: getCellText(receiverName).toString(),
                    receiptNumber: "", // Excel'den gelen veriler için boş bırakıyoruz
                    receiverAddress: getCellText(receiverAddress).toString(),
                    receiverAddressDetail: getCellText(receiverAddressDetail).toString(),
                    receiverPhone:
                        receiverPhoneText.length === 10
                            ? `0${receiverPhoneText}`
                            : receiverPhoneText,
                    orderNumber: getCellText(orderNumber).toString(),
                    receiverLocation,
                    products: [
                        {
                            productName: getCellText(productName).toString(),
                            ingredients: getCellText(ingredients).toString(),
                            amount: getCellText(amount)
                        }
                    ],
                    barcodeIsRequired: false
                };
            });

            const excelValidationResult = validateExcelOrders(createdOrders);

            if (excelValidationResult.isValid) {
                // Validasyon başarılıysa formu güncelle
                const updatedFormData = {
                    ...form.data,
                    orders: createdOrders
                };
                setForm(prevValues => ({
                    ...prevValues,
                    data: updatedFormData
                }));
                message.success(
                    t("newRequest.loadDeliveryPointsFromTemplateSuccess", {
                        ns: "newRequest",
                        orderNumber: createdOrders.length
                    })
                );
                // Hata yoksa eski hataları temizle
                setErrors(prevErrors => {
                    const newErrors = {};
                    Object.keys(prevErrors).forEach(key => {
                        if (!key.startsWith("orders.")) {
                            newErrors[key] = prevErrors[key];
                        }
                    });
                    return newErrors;
                });
            } else {
                // Hata varsa formu güncelleme, imperative modal göster
                Modal.warning({
                    title: "Excel Dosyasında Eksik Bilgiler",
                    width: 500,
                    centered: true,
                    content: (
                        <div>
                            <div
                                style={{
                                    backgroundColor: "#fff7e6",
                                    border: "1px solid #ffd591",
                                    borderRadius: "8px",
                                    padding: "16px",
                                    marginBottom: "20px"
                                }}
                            >
                                <p style={{color: "#ad6800", margin: 0}}>
                                    Yüklediğiniz Excel dosyasında bazı zorunlu alanlar eksik veya
                                    hatalı. Lütfen Excel dosyanızı düzenleyip tekrar yükleyin.
                                </p>
                            </div>
                            <div
                                style={{
                                    backgroundColor: "#fafafa",
                                    borderRadius: "8px",
                                    padding: "16px"
                                }}
                            >
                                <h4 style={{marginBottom: "12px"}}>
                                    Eksik/Hatalı Alanlar (
                                    {excelValidationResult.errorMessages.length} adet)
                                </h4>
                                <ul
                                    style={{
                                        margin: 0,
                                        paddingLeft: "20px",
                                        maxHeight: "200px",
                                        overflowY: "auto"
                                    }}
                                >
                                    {excelValidationResult.errorMessages
                                        .slice(0, 10)
                                        .map((err, idx) => (
                                            <li
                                                key={idx}
                                                style={{color: "#cf1322", marginBottom: "8px"}}
                                            >
                                                {err}
                                            </li>
                                        ))}
                                </ul>
                                {excelValidationResult.errorMessages.length > 10 && (
                                    <div
                                        style={{color: "#999", fontSize: "12px", marginTop: "12px"}}
                                    >
                                        ... ve {excelValidationResult.errorMessages.length - 10}{" "}
                                        hata daha
                                    </div>
                                )}
                            </div>
                        </div>
                    ),
                    okText: "Tekrar Excel Yükle",
                    onOk: () => {
                        if (openUploadModalFn) {
                            openUploadModalFn();
                        }
                    }
                });
            }
        } catch (error) {
            message.error(t("Lütfen yüklemiş olduğunuz excel dosyasını kontrol ediniz."));
        }
    };

    // Excel'den yüklenen orderları validate et
    const validateExcelOrders = orders => {
        let tempErrors = {};
        const errorMessages = [];
        const requiredMessage = t("validation.required", {ns: "common"});

        orders?.forEach((order, orderIndex) => {
            const orderKey = `orders.${orderIndex}`;

            // Müşteri adı kontrolü
            if (!order?.receiverName && !order?.receiptNumber) {
                tempErrors[`${orderKey}.receiverName`] = "Müşteri adı veya fiş numarası zorunludur";
                tempErrors[`${orderKey}.receiptNumber`] =
                    "Müşteri adı veya fiş numarası zorunludur";
                errorMessages.push(`Satır ${orderIndex + 1}: Müşteri adı veya fiş numarası boş`);
            }

            // Telefon kontrolü
            const cleanPhone = order?.receiverPhone?.replace(/[-,(,),_\s]/g, "") || "";
            if (!order?.receiverPhone || cleanPhone.length === 0) {
                tempErrors[`${orderKey}.receiverPhone`] = requiredMessage;
                errorMessages.push(`Satır ${orderIndex + 1}: Telefon numarası boş`);
            } else if (cleanPhone.length !== 11) {
                tempErrors[`${orderKey}.receiverPhone`] = "Telefon numarası 11 haneli olmalıdır";
                errorMessages.push(`Satır ${orderIndex + 1}: Telefon numarası 11 haneli olmalı`);
            }

            // Adres kontrolü
            if (!order?.receiverAddress) {
                tempErrors[`${orderKey}.receiverAddress`] = requiredMessage;
                errorMessages.push(`Satır ${orderIndex + 1}: Adres boş`);
            }

            // Product validasyonu
            order?.products?.forEach((product, productIndex) => {
                const productKey = `${orderKey}.products.${productIndex}`;

                if (!product?.productName || product.productName.trim() === "") {
                    tempErrors[`${productKey}.productName`] = requiredMessage;
                    errorMessages.push(`Satır ${orderIndex + 1}: Ürün adı boş`);
                }

                if (!product?.amount || product.amount <= 0) {
                    tempErrors[`${productKey}.productAmount`] = requiredMessage;
                    errorMessages.push(`Satır ${orderIndex + 1}: Ürün miktarı boş veya geçersiz`);
                }
            });
        });

        return {
            isValid: !Object.values(tempErrors).some(e => e),
            errors: tempErrors,
            errorMessages
        };
    };

    const findCompany = React.useCallback(
        async companyId => {
            const company = stores.appStore.companyListFilter.find(cm => cm._id === companyId);
            return company;
        },
        [stores.appStore.companyListFilter]
    );

    const findSubCompany = React.useCallback(
        async subCompanyId => {
            if (!subCompanyId) {
                return null;
            }

            // Önce mevcut listeden ara
            let subCompany = stores.companyStore.subCompanyList.find(sc => sc._id === subCompanyId);

            // Eğer bulunamazsa API'den al
            if (!subCompany && subCompanyId) {
                try {
                    const response = await stores.companyStore.getSubCompanyList({
                        companyId: stores.meStore.companies?.[0]?._id,
                        limit: 5000
                    });

                    if (response?.rows) {
                        subCompany = response.rows.find(sc => sc._id === subCompanyId);
                    }
                } catch (error) {
                    console.error("Error fetching subcompany:", error);
                }
            }

            return subCompany;
        },
        [stores.companyStore.subCompanyList, stores.meStore.companies]
    );

    const handleSelectCompany = async ({companyId}) => {
        const company = await findCompany(companyId);
        if (!company) return;
        setSelectedCompany(company);

        if (selectedSubCompany && selectedSubCompany.companyId !== companyId) {
            setSelectedSubCompany(undefined);
            setForm(prevForm => ({
                ...prevForm,
                data: {
                    ...prevForm.data,
                    pickupInfos: prevForm.data.pickupInfos.map(pickupInfo => ({
                        ...pickupInfo,
                        pickupPointId: ""
                    }))
                }
            }));
            return;
        }

        setForm({...form});
    };

    const fetchPaymentTypes = React.useCallback(async () => {
        setPaymentTypesLoading(true);
        try {
            const result = await stores.codPaymentStore.paymentTypesForPanel();
            setPaymentTypes(result);
        } catch (error) {
            message.error("Ödeme tipleri yüklenirken bir hata oluştu");
        } finally {
            setPaymentTypesLoading(false);
        }
    }, [stores.codPaymentStore]);

    const handleSelectPickupPoint = React.useCallback(
        async ({subCompanyId}) => {
            const subCompany = await findSubCompany(subCompanyId);
            if (!subCompany) {
                return;
            }
            setSelectedSubCompany(subCompany);

            const company = await findCompany(subCompany?.companyId);
            if (!company) return;
            setSelectedCompany(company);
            await fetchPaymentTypes();
            const pickupInfos = form.data.pickupInfos.map(pickupInfo => {
                return {...pickupInfo, pickupPointId: subCompany._id.toString() || ""};
            });

            // alt firma değiştiğinde alıcı bilgilerini temizle
            const clearedOrders = form.data.orders.map(order => ({
                ...order,
                receiverName: "",
                receiptNumber: "",
                receiverPhone: "",
                receiverAddress: "",
                receiverLocation: undefined,
                receiverAddressDetail: "",
                receiverCity: ""
            }));

            setForm(prevForm => ({
                ...prevForm,
                data: {
                    ...prevForm.data,
                    pickupInfos,
                    orders: clearedOrders
                }
            }));

            const pickupInfoValidResponse = validatePickupInfo({_pickupInfo: pickupInfos});
            // Order'lar temizlendiğinde order hatalarını da temizle
            setErrors(prevErrors => {
                const newErrors = {};
                // Sadece pickupInfo hatalarını koru, order hatalarını temizle
                Object.keys(prevErrors).forEach(key => {
                    if (!key.startsWith("orders.")) {
                        newErrors[key] = prevErrors[key];
                    }
                });
                // Yeni pickupInfo hatalarını ekle
                Object.keys(pickupInfoValidResponse.errors).forEach(key => {
                    newErrors[key] = pickupInfoValidResponse.errors[key];
                });
                return newErrors;
            });
        },
        [findSubCompany, findCompany, fetchPaymentTypes]
    );
    //#endregion pickupInfo

    useEffect(() => {
        const isPoolCustomer = stores.meStore.isPoolCustomer;
        const selectedSubcompanyId = stores.meStore.selectedSubCompanyId;
        const findSelectedSubcompany = async () => {
            const subcompany = await findSubCompany(selectedSubcompanyId);
            if (subcompany) {
                setSelectedSubCompany(subcompany);
                handleSelectPickupPoint({subCompanyId: subcompany?._id});
            }
        };
        if (selectedSubcompanyId && !isPoolCustomer) {
            findSelectedSubcompany();
        }
    }, [
        stores.meStore.selectedSubCompanyId,
        stores.meStore.isPoolCustomer,
        findSubCompany,
        handleSelectPickupPoint
    ]);

    //#region order
    const createOrder = () => {
        const orders = form.data.orders;
        const newOrder = {
            ...orderPrototype,
            index: orders.length,
            orderNumber: generateRandomOrderNumber()
        };
        setForm(prevForm => ({
            ...prevForm,
            data: {...prevForm.data, orders: [...orders, newOrder]}
        }));
    };
    const deleteOrder = ({orderIndex}) => {
        const orders = form.data.orders.filter((order, index) => index !== orderIndex);
        const updatedOrders = orders.map((order, index) => {
            return {...order, index: index};
        });
        const updatedForm = {...form, data: {...form.data, orders: updatedOrders}};
        setForm({...updatedForm});
        validateDelivery({_form: updatedForm});
    };
    const updateOrder = ({orderIndex, order, skipValidation = false}) => {
        setForm(prevForm => {
            const updatedOrders = prevForm.data.orders.map((ord, index) => {
                if (index === orderIndex) {
                    return {...ord, ...order};
                }
                return ord;
            });
            const updatedOrder = updatedOrders[orderIndex];

            if (!updatedOrder?.receiverAddress || !updatedOrder?.receiverLocation) {
                setPolylineResponse(null);
            }

            // Validation'ı setForm dışına taşı - stale closure sorununu önlemek için
            if (!skipValidation) {
                const orderValidResponse = validateOrder({orderIndex, _order: updatedOrder});
                // validateOrder zaten her alan için hata veya null döndürüyor
                // Sadece sonuçları mevcut errors'a merge et
                setErrors(prevErrors => ({
                    ...prevErrors,
                    ...orderValidResponse.errors
                }));
            }

            return {...prevForm, data: {...prevForm.data, orders: updatedOrders}};
        });
    };
    //#endregion order

    //#region product
    const createProduct = ({orderIndex}) => {
        const orders = form?.data?.orders;
        const order = orders?.[orderIndex];
        const products = order?.products;
        const newProduct = {...productPrototype};
        const updatedProducts = [...products, newProduct];
        const updatedOrder = {...order, products: updatedProducts};
        const updatedOrders = orders?.map((ord, index) => {
            if (index === orderIndex) {
                return updatedOrder;
            }
            return ord;
        });
        setForm(prevForm => ({...prevForm, data: {...prevForm.data, orders: updatedOrders}}));
    };
    const deleteProduct = ({orderIndex, productIndex}) => {
        const orders = form?.data?.orders;
        const order = orders?.[orderIndex];
        const products = order?.products;
        const updatedProducts = products?.filter((prd, index) => index !== productIndex);
        const updatedOrder = {...order, products: updatedProducts};
        const updatedOrders = orders?.map((ord, index) => {
            if (index === orderIndex) {
                return updatedOrder;
            }
            return ord;
        });
        const updatedForm = {...form, data: {...form.data, orders: updatedOrders}};
        setForm({...updatedForm});
        validateDelivery({_form: updatedForm});
    };
    const updateProduct = async ({orderIndex, productIndex, product}) => {
        const orders = form?.data?.orders;
        const order = orders?.[orderIndex];
        const products = order?.products;
        const updatedProducts = products?.map((prd, index) => {
            if (index === productIndex) {
                return product;
            }
            return prd;
        });
        const updatedOrder = {...order, products: updatedProducts};
        const updatedOrders = orders?.map((ord, index) => {
            if (index === orderIndex) {
                return updatedOrder;
            }
            return ord;
        });

        setForm(prevForm => ({...prevForm, data: {...prevForm.data, orders: updatedOrders}}));

        const productValidResponse = validateProduct({orderIndex, productIndex, _product: product});
        // validateProduct zaten her alan için hata veya null döndürüyor
        setErrors(prevErrors => ({
            ...prevErrors,
            ...productValidResponse.errors
        }));
    };
    //#endregion product

    //#region error
    const getError = key => {
        return errors?.[key] || null;
    };
    //#endregion error

    //validate form & if not valid set errors
    const validatePickupInfo = ({_pickupInfo = []}) => {
        let tempErrors = {};
        const pickupInfo = _pickupInfo.length !== 0 ? _pickupInfo : form?.data?.pickupInfos;
        console.log("pickupInfo", pickupInfo);
        const requiredMessage = t("validation.required", {ns: "common"});
        pickupInfo?.forEach((pI, index) => {
            if (!pI?.pickupPointId) {
                tempErrors[`pickupInfos.${index}.pickupPointId`] = requiredMessage;
            } else {
                tempErrors[`pickupInfos.${index}.pickupPointId`] = null;
            }
        });
        return {
            isValid: !Object.values(tempErrors).some(e => e),
            errors: tempErrors
        };
    };

    const validateProduct = ({orderIndex, productIndex, _product}) => {
        const key = `orders.${orderIndex}.products.${productIndex}`;
        const product = _product || form?.data?.orders?.[orderIndex]?.products?.[productIndex];
        const requiredMessage = t("validation.required", {ns: "common"});
        const _errors = [];
        if (!product?.productName) {
            _errors[`${key}.productName`] = requiredMessage;
        } else {
            _errors[`${key}.productName`] = null;
        }
        if (!product?.amount) {
            _errors[`${key}.productAmount`] = requiredMessage;
        } else {
            _errors[`${key}.productAmount`] = null;
        }
        return {
            isValid: !Object.values(_errors).some(e => e),
            errors: _errors
        };
    };
    const validateOrder = ({orderIndex, _order}) => {
        const key = `orders.${orderIndex}`;
        const order = _order || form?.data?.orders?.[orderIndex];
        const requiredMessage = t("validation.required", {ns: "common"});
        const _errors = [];

        // Müşteri adı veya fiş numarası kontrolü
        if (!order?.receiverName && !order?.receiptNumber) {
            _errors[`${key}.receiverName`] = "Müşteri adı veya fiş numarası zorunludur";
            _errors[`${key}.receiptNumber`] = "Müşteri adı veya fiş numarası zorunludur";
        } else {
            _errors[`${key}.receiverName`] = null;
            _errors[`${key}.receiptNumber`] = null;
        }

        // Fiş numarası girilmişse telefon ve adres zorunlu değil
        const isReceiptNumberMode = order?.receiptNumber && !order?.receiverName;

        // Adres kontrolü - sadece müşteri adı modunda zorunlu
        if (!isReceiptNumberMode) {
            if (!order?.receiverAddress) {
                _errors[`${key}.receiverAddress`] = requiredMessage;
            } else if (typeof order?.receiverLocation === "undefined") {
                _errors[`${key}.receiverAddress`] = requiredMessage;
            } else {
                _errors[`${key}.receiverAddress`] = null;
            }
        } else {
            _errors[`${key}.receiverAddress`] = null;
        }

        // Telefon kontrolü - sadece müşteri adı modunda zorunlu
        if (!isReceiptNumberMode) {
            const cleanPhone = order?.receiverPhone?.replace(/[-,(,),_\s]/g, "") || "";
            if (!order?.receiverPhone || cleanPhone.length === 0) {
                _errors[`${key}.receiverPhone`] = requiredMessage;
            } else if (cleanPhone.length !== 11) {
                _errors[`${key}.receiverPhone`] = "Telefon numarası 11 haneli olmalıdır";
            } else {
                _errors[`${key}.receiverPhone`] = null;
            }
        } else {
            _errors[`${key}.receiverPhone`] = null;
        }

        return {
            isValid: !Object.values(_errors).some(e => e),
            errors: _errors
        };
    };
    const validateDelivery = ({_form = form.data}) => {
        let tempErrors = {};
        console.log("_form", _form);
        //validate pickup point
        const pickupInfoValidResponse = validatePickupInfo({_pickupInfo: _form.pickupInfos});
        tempErrors = {...tempErrors, ...pickupInfoValidResponse.errors};

        _form?.orders?.forEach((order, index) => {
            const orderValidResponse = validateOrder({orderIndex: index, _order: order});
            tempErrors = {...tempErrors, ...orderValidResponse.errors};

            order?.products?.forEach((product, pIndex) => {
                const productValidResponse = validateProduct({
                    orderIndex: index,
                    productIndex: pIndex,
                    _product: product
                });
                tempErrors = {...tempErrors, ...productValidResponse.errors};
            });
        });

        setErrors({...tempErrors});
        console.log("tempErrors", tempErrors);
        return {
            isValid: !Object.values(tempErrors).some(e => e),
            errors: tempErrors
        };
    };

    const getValidationErrorMessages = errors => {
        const errorMessages = [];
        Object.keys(errors).forEach(key => {
            if (errors[key]) {
                // Product validation errors - UI'da inputu olmayan alanlar için mesaj oluştur
                if (key.includes("productName")) {
                    const orderIndex = key.match(/orders\.(\d+)/)?.[1];
                    const productIndex = key.match(/products\.(\d+)/)?.[1];
                    if (orderIndex !== undefined && productIndex !== undefined) {
                        errorMessages.push(
                            `Sipariş ${parseInt(orderIndex) + 1} - Ürün ${parseInt(productIndex) +
                                1}: Ürün adı boş olamaz`
                        );
                    }
                }
                if (key.includes("productAmount")) {
                    const orderIndex = key.match(/orders\.(\d+)/)?.[1];
                    const productIndex = key.match(/products\.(\d+)/)?.[1];
                    if (orderIndex !== undefined && productIndex !== undefined) {
                        errorMessages.push(
                            `Sipariş ${parseInt(orderIndex) + 1} - Ürün ${parseInt(productIndex) +
                                1}: Ürün miktarı boş olamaz`
                        );
                    }
                }
            }
        });
        return errorMessages;
    };

    const submitDeliveryRequest = async () => {
        const validationResult = validateDelivery({});
        console.log("validationResult", validationResult);
        console.log("form.data", form.data);
        if (!validationResult.isValid) {
            // UI'da inputu olmayan alanlar için hata mesajı göster
            const hiddenFieldErrors = getValidationErrorMessages(validationResult.errors);
            if (hiddenFieldErrors.length > 0) {
                message.error({
                    content: (
                        <div>
                            <div style={{fontWeight: "bold", marginBottom: 8}}>
                                Lütfen aşağıdaki hataları düzeltin:
                            </div>
                            {hiddenFieldErrors.map((err, idx) => (
                                <div key={idx}>• {err}</div>
                            ))}
                        </div>
                    ),
                    duration: 5
                });
            }
            return;
        }

        //submit form
        const isDedicatedIntegration =
            stores.meStore?.pool?.integrationType === "dedicatedIntegration";

        const data = {
            ...form.data,
            orders: form.data.orders.map(order => {
                const orderData = {
                    ...order,
                    index: order.index + 1,
                    receiverPhone: order.receiverPhone
                        ? order.receiverPhone.replace(/[-,(,),_]/g, "")
                        : "",
                    receiverLocation:
                        isDedicatedIntegration && !order.receiverAddress
                            ? {lon: 0, lat: 0}
                            : order.receiverLocation || {lon: 0, lat: 0}
                };

                // Sadece dolu olan alanı gönder
                if (order.receiverName && !order.receiptNumber) {
                    orderData.receiverName = order.receiverName;
                    delete orderData.receiptNumber;
                } else if (order.receiptNumber && !order.receiverName) {
                    orderData.receiptNumber = order.receiptNumber;
                    delete orderData.receiverName;
                } else if (order.receiverName && order.receiptNumber) {
                    // Her ikisi de doluysa, receiverName'i öncelikli olarak gönder
                    orderData.receiverName = order.receiverName;
                    delete orderData.receiptNumber;
                }

                return orderData;
            })
        };

        const pricePromises = data.orders.map(order =>
            stores.subCompanyStore
                .calculatePrice({
                    subCompanyId: selectedSubCompany?._id,
                    receiver: {
                        address: order.receiverAddress,
                        location: {
                            latitude: order.receiverLocation?.lat,
                            longitude: order.receiverLocation?.lon
                        }
                    }
                })
                .then(response => ({
                    ...response,
                    orderNumber: order.orderNumber
                }))
        );
        const userRole = stores.meStore.role || "user";
        const priceResponses = await Promise.all(pricePromises);
        const shouldSkipConfirmation =
            priceResponses.some(response => response?.data?.isWorkWithCredit === false) ||
            userRole === "admin";
        if (shouldSkipConfirmation) {
            const params = {
                body: data,
                companyId: selectedSubCompany?.companyId
            };
            const response = await stores.orderStore.createOrder(params);
            if (response?.status === 200) {
                trackCreateDelivery("manual", fromCustomerTheme ? "customer" : "admin", stores);

                if (fromCustomerTheme) {
                    history.push("/musteri/siparislerim?orderType=current");
                } else {
                    history.push("/orders?orderType=current");
                }
            }
            return;
        }
        if (priceResponses.some(response => response?.status !== 200)) {
            return;
        }
        const orderDetails = priceResponses.map(priceResponse => ({
            orderNumber: priceResponse.orderNumber,
            distancePrice: priceResponse?.data?.detail?.distancePrice || 0,
            packagePrice: priceResponse?.data?.detail?.packagePrice || 0,
            distance: priceResponse?.data?.detail?.distance || 0,
            extraDistance: priceResponse?.data?.detail?.extraDistance || 0,
            totalPrice: priceResponse?.data?.price || 0
        }));

        const totalOrdersPrice = orderDetails.reduce((sum, order) => {
            return sum + (order.totalPrice || 0);
        }, 0);

        const handleApprove = async () => {
            try {
                const params = {
                    body: data,
                    companyId: selectedSubCompany?.companyId
                };
                const response = await stores.orderStore.createOrder(params);
                if (response?.status === 200) {
                    trackCreateDelivery("manual", fromCustomerTheme ? "customer" : "admin", stores);
                    setShowCustomerModal(false);
                    setModalData(null);
                    if (fromCustomerTheme) {
                        history.push("/musteri/siparislerim?orderType=current");
                    } else {
                        history.push("/orders?orderType=current");
                    }
                } else if (fromCustomerTheme) {
                    setCreditWarningMessage(response?.data?.message || "Bir hata oluştu");
                    setShowCreditWarningModal(true);
                } else {
                    message.error("Sipariş oluşturulurken bir hata oluştu");
                }
            } catch (error) {
                if (fromCustomerTheme) {
                    setCreditWarningMessage("Bir hata oluştu");
                    setShowCreditWarningModal(true);
                } else {
                    message.error("Sipariş oluşturulurken bir hata oluştu");
                }
            }
        };

        setModalData({
            orderDetails,
            totalOrdersPrice,
            payload: {
                data,
                companyId: selectedSubCompany?.companyId
            },
            fromCustomerTheme,
            history,
            onApprove: handleApprove
        });
        setShowCustomerModal(true);
    };

    const markerList = useMemo(() => {
        const pickupPoints = [selectedSubCompany]
            .filter(p => p?._id.toString())
            .map((pickupPoint, index) => {
                return {
                    index: index,
                    title: `${index + 1}`,
                    color: "red",
                    location: {
                        latitude: pickupPoint?.location?.latitude || 0,
                        longitude: pickupPoint?.location?.longitude || 0
                    }
                };
            });
        const deliveryPoints = form.data.orders
            .filter(
                order =>
                    order?.receiverLocation?.lat &&
                    order?.receiverLocation?.lon &&
                    order?.receiverAddress
            )
            .map((order, index) => {
                return {
                    index: index,
                    title: `${index + 2}`,
                    color: "gray",
                    location: {
                        latitude: order?.receiverLocation?.lat || 0,
                        longitude: order?.receiverLocation?.lon || 0
                    }
                };
            });

        return [...pickupPoints, ...deliveryPoints];
    }, [
        selectedSubCompany,
        JSON.stringify(
            form?.data?.orders?.map(order => ({
                receiverLocation: order?.receiverLocation,
                receiverAddress: order?.receiverAddress
            }))
        )
    ]);

    const polylineRequestData = useMemo(() => {
        if (!selectedSubCompany || form.data.orders.length === 0) {
            return null;
        }

        const validDeliveryPoints = form.data.orders.filter(
            order =>
                order?.receiverLocation?.lat &&
                order?.receiverLocation?.lon &&
                order?.receiverAddress
        );

        if (validDeliveryPoints.length === 0) {
            return null;
        }

        const fromPoint = [
            selectedSubCompany?.location?.longitude || 0,
            selectedSubCompany?.location?.latitude || 0
        ];

        const toPoints = validDeliveryPoints.map(order => [
            order.receiverLocation.lon,
            order.receiverLocation.lat
        ]);

        return {
            from_points: [fromPoint],
            to_points: toPoints
        };
    }, [
        selectedSubCompany,
        JSON.stringify(
            form?.data?.orders?.map(order => ({
                receiverLocation: order?.receiverLocation,
                receiverAddress: order?.receiverAddress
            }))
        )
    ]);

    const [polylineLoading, polylineResponse, setPolylineResponse, setPolylineLoading] = useFetch({
        fetchFn: () => stores.orderStore.getPolylineBetweenLocations(polylineRequestData),
        dependencies: [JSON.stringify(polylineRequestData)],
        condition: !!polylineRequestData,
        defaultDataValue: null,
        initialCall: false
    });

    const polylineData = useMemo(() => {
        if (!polylineRequestData) {
            return null;
        }
        return polylineResponse?.data?.data || null;
    }, [polylineRequestData, polylineResponse]);

    // Reverse geocoding function
    const reverseGeocode = async (lat, lng) => {
        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1`
            );
            const data = await response.json();
            if (data && data.display_name) {
                return {
                    address: data.display_name,
                    city: data?.address?.province || ""
                };
            } else {
                throw new Error("Adres bulunamadı.");
            }
        } catch (error) {
            throw new Error("Geocoding service unavailable");
        }
    };

    const preserveRecipientFields = order => {
        const fieldsToPreserve = {};
        if (order?.receiverName) {
            fieldsToPreserve.receiverName = order.receiverName;
        }
        if (order?.receiptNumber) {
            fieldsToPreserve.receiptNumber = order.receiptNumber;
        }
        if (order?.receiverPhone) {
            fieldsToPreserve.receiverPhone = order.receiverPhone;
        }
        return fieldsToPreserve;
    };

    // Handle map click - add pin to clicked location
    const handleMapClick = async ({lat, lng}) => {
        let currentOrders = [];
        let shouldCreateNewOrder = false;

        setForm(prevForm => {
            currentOrders = prevForm.data.orders;

            if (currentOrders.length === 0) {
                shouldCreateNewOrder = true;
                const newOrder = {
                    ...orderPrototype,
                    index: 0,
                    orderNumber: generateRandomOrderNumber()
                };
                const updatedOrders = [newOrder];

                return {
                    ...prevForm,
                    data: {...prevForm.data, orders: updatedOrders}
                };
            }
            return prevForm;
        });

        if (shouldCreateNewOrder) {
            // Wait a bit for the state to update, then update the new order
            setTimeout(async () => {
                try {
                    const geocodeResult = await reverseGeocode(lat, lng);
                    updateOrder({
                        orderIndex: 0,
                        order: {
                            receiverLocation: {lat, lon: lng},
                            receiverAddress: geocodeResult?.address,
                            receiverCity: geocodeResult?.city || ""
                        }
                    });
                } catch (error) {
                    updateOrder({
                        orderIndex: 0,
                        order: {
                            receiverLocation: {lat, lon: lng}
                        }
                    });
                }
            }, 100);
            return;
        }

        if (currentOrders.length > 0) {
            const emptyOrderIndex = currentOrders.findIndex(
                order =>
                    !order.receiverLocation ||
                    !order.receiverLocation.lat ||
                    !order.receiverLocation.lon ||
                    !order.receiverAddress
            );

            const targetOrderIndex =
                emptyOrderIndex !== -1 ? emptyOrderIndex : currentOrders.length - 1;
            const targetOrder = currentOrders[targetOrderIndex];
            const preservedFields = preserveRecipientFields(targetOrder);

            try {
                const geocodeResult = await reverseGeocode(lat, lng);
                updateOrder({
                    orderIndex: targetOrderIndex,
                    order: {
                        ...preservedFields,
                        receiverLocation: {lat, lon: lng},
                        receiverAddress: geocodeResult?.address,
                        receiverCity: geocodeResult?.city || targetOrder?.receiverCity || ""
                    }
                });
            } catch (error) {
                updateOrder({
                    orderIndex: targetOrderIndex,
                    order: {
                        ...preservedFields,
                        receiverLocation: {lat, lon: lng}
                    }
                });
            }
        }
    };

    return {
        createDeliveryRequestForm: form,
        selectedCompany,
        selectedSubCompany,
        handleExcelUpload,
        markerList,
        orderList: form.data.orders,
        handleSelectCompany,
        handleSelectPickupPoint,
        paymentTypes,
        paymentTypesLoading,

        /*----polyline----*/
        polylineData,
        polylineLoading,

        /*----order----*/
        createOrder,
        addOrder: createOrder,
        updateOrder,
        deleteOrder,

        /*----product----*/
        createProduct,
        updateProduct,
        deleteProduct,

        /*----error----*/
        getError,

        /*----submit----*/
        submitDelivery: submitDeliveryRequest,

        /*----geocoding----*/
        reverseGeocode,
        handleMapClick,

        /*----modal----*/
        showCustomerModal,
        setShowCustomerModal,
        modalData,
        showCreditWarningModal,
        setShowCreditWarningModal,
        creditWarningMessage,
        setCreditWarningMessage,

        /*----excel upload modal----*/
        setOpenUploadModalFn
    };
};
